var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper"},[_vm._m(0),_c('div',{staticClass:"contents-wrapper"},_vm._l((_vm.frequentlyProductList),function(item,index){return _c('product-list-item',{key:`product_${index}`,attrs:{"item":item,"isWish":false}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-wrapper"},[_c('b',{staticClass:"title"},[_vm._v("자주 주문한 상품")])])
}]

export { render, staticRenderFns }